module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6wo0r"))).then(() => parcelRequire('dJXJK'));